import { io } from "socket.io-client";
import { authStorage, storage } from "../utils/storage";
import { API_CONFIG } from "./api";
import Cookies from "js-cookie";

let socket = null;

// Encode data as Blob before emitting (matches old frontend Helper.js)
export function encode(data) {
  try {
    return new Blob([JSON.stringify(data)]);
  } catch (e) {
    return null;
  }
}

// Decode binary response from socket (matches old frontend Helper.js)
export function decode(data) {
  try {
    // Handle ArrayBuffer
    if (data instanceof ArrayBuffer) {
      return JSON.parse(new TextDecoder().decode(data));
    }
    // Handle Uint8Array or other typed arrays
    if (data?.buffer instanceof ArrayBuffer) {
      return JSON.parse(new TextDecoder().decode(data));
    }
    // Handle Blob
    if (data instanceof Blob) {
      // Can't decode blob synchronously, shouldn't happen
      return null;
    }
    // Handle plain object (already decoded by socket.io)
    if (typeof data === "object" && data !== null) {
      return data;
    }
    // Handle string
    if (typeof data === "string") {
      return JSON.parse(data);
    }
    return null;
  } catch (e) {
    console.error("[Socket] decode error:", e);
    return null;
  }
}

export function connectSocket() {
  if (socket) return socket; // Already created, don't create another
  const token = authStorage.getToken();
  socket = io.connect(API_CONFIG.SOCKET_URL, {
    secure: true,
    withCredentials: false,
    query: {
      auth_token: token,
      user_key: storage.getKey("key"),
    },
  });

  socket.on("connect", () => {
    console.log("[Socket] Connected:", socket?.id);
    const uid = parseFloat(Cookies.get("uid"));
    if (uid) {
      socket.emit("identify", uid, (ok) => {
        console.log("[Socket] identify ok:", ok);
      });
    }
  });

  socket.on("disconnect", (reason) => console.log("[Socket] Disconnected:", reason));
  socket.on("connect_error", (error) => console.error("[Socket] Error:", error.message));
  return socket;
}

export function getSocket() {
  if (!socket) connectSocket();
  return socket;
}

export function disconnectSocket() {
  if (socket) { socket.disconnect(); socket = null; }
}

export function emitSocket(event, data) {
  const s = getSocket();
  if (s?.connected) s.emit(event, data);
}

export function onSocket(event, callback) {
  const s = getSocket();
  s?.on(event, callback);
}

export function offSocket(event, callback) {
  const s = getSocket();
  s?.off(event, callback);
}
